import { createFileRoute } from '@tanstack/react-router'
import { requireTrainer } from '@/lib/auth-guards'
import { TrainerAssignPage } from '@/features/trainers'

export const Route = createFileRoute('/_authenticated/trainer/assign')({
  beforeLoad: async () => {
    await requireTrainer()
  },
  component: TrainerAssignPage,
})
